const config = {
    // api: "http://localhost:8000/api/",
    api: "/api/",
}

export default config;
